import React, { useContext } from "react"
import { themeContext } from "global/context/sub-contexts/themeContext"

import CardStructure from "components/index/CardStructure"
import Layout from "global/layout/Layout"
import SEO from "global/layout/Seo"
import "./Category.scss"
import Pagination from "templates/components/Pagination"
import { taxonomyClassNames } from 'util/misc';
import { graphql } from "gatsby"

/*

    This functions identically to the CategoryTemplate
    db_type is some other taxonomy that isn't a category or a tag

*/

const TypeTemplate = ({
  data,
  pageContext: { currentPage, numPages, typeSlug, type_label },
}) => {
  //always reset styles from themes
  let colors = useContext(themeContext)

  const pageTitle = data.site.siteMetadata.title + " | " + type_label

  if (colors) {
    colors.styles.mission = false
    colors.styles._mission = false
  }
  return (
    <Layout>
      <main className={taxonomyClassNames(currentPage, typeSlug)}>
        <SEO title={pageTitle} />
        <section className="section section-break">
          <div className="container">
            <div className="row">
              <CardStructure
                breaks={data.allBreak.nodes}
                tag={typeSlug}
                sectionTitle={type_label}
                showAll={true}
              />
            </div>
          </div>
          <Pagination currentPage={currentPage} numPages={numPages} baseSlug={`tag/${typeSlug}`}  />
        
        </section>
      </main>
    </Layout>
  )
}

// skip, limit, type_key get passed in via context in createPage() call
export const pageQuery = graphql`
  query breaksByTypeQuery($skip: Int!, $limit: Int!, $type_key: String!, $lang: String!) {
    site {
        siteMetadata {
          title
        }
    }
    allBreak(skip: $skip, limit: $limit, filter: {types: {eq: $type_key}, lang: {eq: $lang}, isSponsored: {eq: false}}) {
        nodes {
            displayDateEpoch
            featuredImageUrl
            heroImageUrl
            permalink
            title
            step_types
            points
            id
        }
    }

  }

`

export default TypeTemplate
